const config = require("../config")
const url = config.base_dev_url + "container_phenology_sample_files_speak_title"

module.exports = {
    getFarmSpeakInfo: {
        url: url + "/getFarmSpeakInfo",
        type: "get",
    },
    phenologyBroadcast: {
        url: config.base_dev_url + "farm_broadcast/phenologyBroadcastByFarmId",
        type: "get",
    },
}